<template>
  <div>
    <div v-for="(person, index) in existingPeopleList" :key="index">
      <v-btn
        block
        depressed
        class="existing-item-btn"
        :disabled="personDisabled(person)"
        @click="addExistingPerson(person)"
      >
        <div class="existing-item-text">
          <span class="existing-item-name">{{ person.fullName }}</span
          ><br />
          <span class="existing-item-extra-info">{{
            person.disabledMessage || formatPersonKinship(person.kinship)
          }}</span>
        </div>
        <div>
          <v-progress-circular
            v-if="buttonLoading == person.id"
            size="24"
            indeterminate
            color="primary"
          />
          <v-icon v-else class="plus-icon" color="primary">{{
            icons.mdiPlusCircle
          }}</v-icon>
        </div>
      </v-btn>
    </div>
  </div>
</template>

<script>
  import { CREATE_TESTATOR_RELATIONSHIP_MUTATION } from '../../constants/graphql/people';
  import { TESTATOR_QUERY } from '../../constants/graphql/testators';
  import { formatKinship } from '../../constants/js/people.js';

  export default {
    name: 'PersonDialogExistingPeople',
    props: {
      existingPeopleList: { type: Array },
      createNewRelationship: { type: Boolean, default: true },
      relation: { type: String, required: true },
      testator: { type: Object },
      decisionMaker: {
        required: false,
        default: false,
        type: [String, Boolean],
      },
      emergencyContacts: {
        required: false,
        default: false,
        type: [String, Boolean],
      },
    },
    data() {
      return {
        buttonLoading: 0,
      };
    },
    methods: {
      addExistingPerson(person) {
        this.buttonLoading = person.id;
        const dataMissing = this.isPersonDataMissing(person);

        if (this.createNewRelationship && !dataMissing) {
          this.createTestatorRelationship(person);
        } else if (this.createNewRelationship && dataMissing) {
          this.$emit('existingPersonSelectedWithMissingData', person);
          this.buttonLoading = 0;
        } else {
          this.$emit('closeDialog');
          this.$emit('existingPersonSelected', person);
          this.buttonLoading = 0;
        }
      },
      createTestatorRelationship(person) {
        const testatorRelationshipInputDetails = {
          relation: this.relation,
          personId: person.id,
        };

        this.$apollo
          .mutate({
            mutation: CREATE_TESTATOR_RELATIONSHIP_MUTATION,
            variables: {
              testatorRelationshipInputDetails,
            },
            update: (cache, { data: { createTestatorRelationship } }) => {
              this.updateCacheAfterCreateTestatorRelationship(
                cache,
                createTestatorRelationship
              );
            },
          })
          .then(_response => {
            this.$emit('closeDialog');
            this.buttonLoading = 0;
          })
          .catch(error => {
            this.$emit('errorThrown');
            this.buttonLoading = 0;
            throw error;
          });
      },
      updateCacheAfterCreateTestatorRelationship(
        cache,
        createTestatorRelationship
      ) {
        const query = {
          query: TESTATOR_QUERY,
          variables: { id: this.testatorId },
        };
        const data = cache.readQuery(query);

        var person = data.testator.people.find(
          p => p.id == createTestatorRelationship.personId
        );
        person.testatorRelationships.push(createTestatorRelationship);

        cache.writeQuery({ ...query, data: data });
      },
      formatPersonKinship(kinship) {
        return formatKinship(kinship, this.testator);
      },
      personDisabled(person) {
        return person.disabledMessage ? true : false;
      },
      isPersonDataMissing(person) {
        if (this.relation == 'INSURANCE_NOMINATED_BENEFICIARY') {
          const idMissing = !person.identityNumber;
          const genderMissing = person.kinship == 'CHILD' && !person.gender;

          return idMissing || genderMissing;
        } else if (
          this.decisionMaker &&
          (!person.email || !person.dateOfBirth)
        ) {
          return true;
        } else if (
          this.emergencyContacts &&
          (!person.email || !person.contactNumber)
        ) {
          return true;
        } else {
          return false;
        }
      },
    },
  };
</script>
